/*
 * File: fascicle-list.component.ts                                            *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { CatalogService } from '../../../services/catalog.service';
import { FascicleService } from '../../../services/fascicle.service';
import { FascicleSocketService } from '../../../services/fascicle-socket.service';
import { UserService } from '../../../../user/services/user.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { User } from '@nousmedis/guard-types/dist/frontend';
import { MessageService } from 'primeng/api';
import { Fascicle } from '@nousmedis/cc-types';

@Component({
  selector: 'app-fascicle-list',
  templateUrl: './fascicle-list.component.html',
  styleUrls: ['./fascicle-list.component.scss'],
})
export class FascicleListComponent implements OnInit, OnDestroy {
  dataSuscribe: any;
  dataTableSuscribe: any;
  loadingSuscribe: any;
  socketSuscribe: Subscription;

  //Lo recibo de la lista de catálogos, parece ser que es el mismo y la api no lo devuelve.
  @Input() templateName: string;
  @Input() idCatalog: string;

  dataLoaded: boolean = false;
  loading: boolean = false;
  catalogName: string = '';
  dataSource: Fascicle[];
  dataTable: Array<Fascicle>;

  row: any;
  pageFrom = 0;
  viewActions: boolean = false;
  user: User;
  currentUserId: string = '';

  // @ViewChild('fasTable') table: MatTable<Fascicle>;

  @Input() set dataInput(value: Array<Fascicle>) {
    this.dataTable = this.fascicleService.setFromToPages(value);
    this.dataSource = this.dataTable;
    this.dataLoaded = true;
  }

  constructor (
    private fascicleService: FascicleService,
    private catalogService: CatalogService,
    private messageService: MessageService,
    private userService: UserService,
    private socket: FascicleSocketService,
    private router: Router
  ) {
    this.dataSource = [];
  }

  ngOnInit(): void {
    this.dataLoaded = true;
    this.user = this.userService.user;
    this.currentUserId = this.user?.id ?? '';

    this.socketSuscribe = this.socket.fasciclesChanged.subscribe((change) => {
      this.reload();
    });


    this.dataSuscribe = this.fascicleService.dataTableFascicles.subscribe(
      (data) => {
        this.dataSource = data;
      }
    );

    this.dataTableSuscribe = this.fascicleService.dataFascicles.subscribe(
      (data) => {
        this.dataTable = data;
      }
    );

    this.loadingSuscribe = this.fascicleService.loadingFascicle.subscribe(
      (load) => {
        this.loading = load;
      }
    );
  }

  ngOnDestroy(): void {
    this.dataSuscribe.unsubscribe();
    this.dataTableSuscribe.unsubscribe();
    this.loadingSuscribe.unsubscribe();
    this.socketSuscribe.unsubscribe();
    // this.socket.fasciclesChanged.unsubscribe();
  }

  handleMouseOver(row: any) {
    if (!this.loading) {
      row.isHover = true;
      if (document.getElementById('actions-row-' + row.id))
        document
          .getElementById('actions-row-' + row.id)
          .classList.remove('actions-translucent');
      if (document.getElementById('move-' + row.id))
        document
          .getElementById('move-' + row.id)
          .classList.remove('move-fascicle-translucent');
    }
  }

  handleMouseLeave(row: any) {
    if (!this.loading) {
      row.isHover = false;
      if (document.getElementById('actions-row-' + row.id))
        document
          .getElementById('actions-row-' + row.id)
          .classList.add('actions-translucent');
      if (document.getElementById('move-' + row.id))
        document
          .getElementById('move-' + row.id)
          .classList.add('move-fascicle-translucent');
    }
  }

  changeFascicleOrder(event: any) {
    this.loading = true;
  
    // Reordenar el array localmente
    const movedItem = this.dataSource[event.dragIndex];
    this.dataSource.splice(event.dragIndex, 1);
    this.dataSource.splice(event.dropIndex, 0, movedItem);
  
    // Actualizar el orden en el backend
    this.fascicleService.updateFascicleOrder(this.idCatalog, this.dataSource);
    this.fascicleService.setFromToPages(this.dataSource);
  
    this.loading = false;
  }

  openFascicleSettings(id: string) {
    this.router.navigate(['/catalog', this.idCatalog, 'fascicles', id, 'edit']);
  }

  editFascicle(id: string) {
    this.fascicleService.openFascicleForm(id, this.idCatalog);
  }

  reload() {
    if (!this.idCatalog) return;
    this.catalogService.getCatalog(this.idCatalog).subscribe((data) => {
      if (!data?.fascicles) return;
      this.dataTable = this.fascicleService.setFromToPages(data.fascicles);
      this.dataSource = this.dataTable;
    });
  }

  clone(id: string) {
    this.fascicleService.clone(this.idCatalog, id).subscribe((data) => {
      this.dataLoaded = true;
      this.reload();
      this.messageService.add({
        severity: 'success',
        summary: 'Fascículo clonado',
        detail: 'Fascículo clonado',
      }
      );
    });
  }

  async delete(id: string, catalog: string) {

  }

  showFromTo(fascicle: Fascicle) {
    let from = this.pageFrom + 1;
    let to = fascicle.totalPages + this.pageFrom;

    this.pageFrom = to;
    return from + ' - ' + to;
  }

  requestUnBlock(fascicle: Fascicle) {
    this.fascicleService.get(this.idCatalog, fascicle.id).subscribe((fasc) => {
      //
      this.socket.sendUnblockRequestFascicle(
        this.idCatalog,
        fascicle.id,
        this.user.id,
        fasc.blockedBy
      );
    });
  }

  onRequestUnblock(fascicle: Fascicle): void {
    this.requestUnBlock(fascicle);
  }

  onForceUnblock(fascicle: Fascicle): void {
    this.fascicleService.unblock(this.idCatalog, fascicle.id).subscribe(() => {
      this.socket.sendChanges(this.idCatalog, fascicle.id, this.user.id, false);
      this.reload();
      this.messageService.add({
        severity: 'success',
        summary: 'Fascículo desbloqueado',
        detail: `El fascículo "${fascicle.name}" ha sido desbloqueado.`,
      });
    });
  }
}
